import { Box, Button, Form, TextInput } from "grommet";
import React, { useEffect } from "react";

import axios from "../general/HttpClient";
import { useNavigate } from "react-router-dom";

const Loin = () => {
    const [message, setMessage] = React.useState("");

    const navigate = useNavigate();

    useEffect(() => {
        axios.get("/api/Authentication").then((response) => {
            if (response.data) {
                navigate("/admin/subject");
            }
        });
    }, []);

    return (
        <Box direction="row" align="center" justify="center" fill>
            <Box pad={"small"} background="background-front" round="small">
                <Form
                    onSubmit={({ value }) => {
                        axios.post("/api/Authentication", { email: value.email }).then((response) => {
                            setMessage("Check your email");
                        });
                    }}
                >
                    <Box gap="small">
                        <TextInput name="email" placeholder="Email" />
                        <Button type="submit" label="Login"></Button>
                        {message}
                    </Box>
                </Form>
            </Box>
        </Box>
    );
};

export default Loin;
